export async function safeFetch(url, options = {}) {
    try {
      const res = await fetch(url, options);
  
      if (!res.ok) {
        console.warn("Backend returned error:", res.status);
        return null;
      }
  
      return await res.json();
    } catch (err) {
      console.warn("Backend unreachable:", err);
      return null;
    }
  }
  